import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Stack,
    Typography,
    styled
} from '@mui/material';

import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { Icon } from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { Menu } from '@mui/material';
import _ from 'lodash';
import { useCallback, useRef, useState } from 'react';
import { Toolbar as AdminToolbar, FormWithRedirect, SaveButton, useNotify, useUpdate } from 'react-admin';
import { useQueryClient } from 'react-query';
import { useLocation } from 'react-router';
import VaultConnectionAspireForm from './VaultConnectionAspireForm';
import VaultConnectionBuddypunchForm from './VaultConnectionBuddypunch';
import VaultConnectionBusyBusyForm from './VaultConnectionBusyBusyForm';
import VaultConnectionJobberForm from './VaultConnectionJobberForm';
import VaultConnectionProcoreForm from './VaultConnectionProcore';
import VaultConnectionTSheetForm from './VaultConnectionTSheetForm';
import { useAddVaultConnection, useAuthorizeVaultConnection, useDisconnectConnection, useUpdateConnectionConfiguration } from './useVaultConnection';
import { ALERT_LARGE_ICON, INTEGRATION_DOWN_ARROW, INTEGRATION_RIGHT_ARROW } from '../../utils/Constants/ClassName';
import protivLogo from '../../assets/protiv-logo-icon.svg';
import SalesForceLogo from '../../assets/integraions/salesforce.svg';
import { useConnectorAuth } from '../connectors/ConnectorAuthContext';
import VaultConnectionServiceTitanForm from './VaultConnectionServiceTitan';
import { useAttendanceConnector } from '../attendances/useAttendanceConnector';



export const VaultConnectionCardDialog = ({open, connection, handleClose}) => {
    const {search} = useLocation()
    const params = new URLSearchParams(search);
    const [isOpen, setIsOpen] = useState(false);
    const [error, setError] = useState("");
    const notify = useNotify();
    const closeMenu = useCallback(()=>{
      setIsOpen(false);
      handleClose();
    },[handleClose, setIsOpen])
    const configurationKeys = Object.keys(connection?.configuration);
    const {updateConnectionConfiguration, isLoading:isLoadingSaveConfiguration} = useUpdateConnectionConfiguration()
    const {addConnection, isLoading: isLoadingAddVault} = useAddVaultConnection()
    const {authorizeConnection, isLoading: isLoadingAuthorizeVault} = useAuthorizeVaultConnection();
    const [update] = useUpdate();
    const { setIsAuthenticated } = useConnectorAuth();
    const {isCostCodeImported}=useAttendanceConnector()
    const onClickAuthorize = useCallback((data:any) => {
        console.log("onClickAuthorize", data)
        setError("")
        addConnection({number:connection.number || 1,service_id: connection.service, redirect_uri:window.location.href, configuration: data}, {
            onSuccess:(connection)=>{
                console.log("Connection added", connection, connection.authorization_url)
                if(!_.isEmpty(connection.authorization_url)){
                    window.location = connection.authorization_url
                    handleCompanySetting()
                } else {
                    authorizeConnection({id: connection.id, service_id: connection.service, configuration: data}, {
                        onSuccess:(authorization)=>{
                            handleCompanySetting();
                            handleClose();
                            setIsAuthenticated(true);
                        },
                        onError: (error) => {
                            console.log("Create authorize failure response:", error)
                            setError(error.error.message);
                            notify(`${error.error.message}`);
                        },
                    })
                }
            }

        })
    },[connection, addConnection])

    const onClickSave = useCallback((data:any)=>{
        console.log("onClickSave", data)
        setError("")
        updateConnectionConfiguration(connection.id, {configuration: data}, {
            onSuccess:(connection)=>{
                console.log("Connection configuration saved", connection)
                if(!_.isEmpty(connection.authorization_url)){
                    handleClose();
                } else {
                    authorizeConnection({id: connection.id, service_id: connection.service, configuration: data}, {
                        onSuccess:(authorization)=>{
                            console.log("authorization:",authorization)
                            handleClose();
                        },
                        onError: (error) => {
                            console.log("Create authorize failure response:", error)
                            setError(error.error.message);
                            notify(`${error.error.message}`);
                        },
                    })
                }

            }

        })
    },[connection, updateConnectionConfiguration, handleClose])

    const handleCompanySetting = ()=>{
        const data = JSON.parse(localStorage.getItem('loginUser'));
        const companyId = data.company_id
        const prValues = {
            id:companyId,
            can_use_cost_code:data.company.can_use_cost_code,
            allow_all_workers_to_add_time:data.company.allow_all_workers_to_add_time
        }
        const values = {
            can_use_cost_code: isCostCodeImported ,
            allow_all_workers_to_add_time:false
        }
        update(
            'company',
            { id: companyId, data: values ,previousData:prValues},
            {
                mutationMode: 'pessimistic',
                onError: (error: any) => {
                    notify(`Element Failed Updated ${error.message}`);
                },
            }
        );
    }


    const loading = isLoadingAddVault || isLoadingAuthorizeVault;
    const saveLoading = isLoadingSaveConfiguration || isLoadingAuthorizeVault;
    return (
        <FormWithRedirect initialValues={connection.configuration} render={(formProps: any) => {
            return (
                <Dialog
                    open={open}
                    maxWidth="sm"
                    sx={{
                        '.MuiDialog-paper .MuiDialogActions-root': {
                            paddingTop: 0,
                        },
                    }}
                    className='common-dialog-modal integration-connect-modal'
                >
                    <DialogTitle
                        style={{ cursor: 'move' }}
                        id="draggable-dialog-title"
                    >
                        <Stack
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                        >
                            {/* <ConnectionDialogMoreMenu isOpen={isOpen} setIsOpen={setIsOpen}>
                            <MenuItem className='busy-busy-disconnect-loader'>
                                <ListItemIcon>
                                    <BlockIcon />
                                    </ListItemIcon>
                                    <DisconnectMenuItem connection={connection} closeMenu={closeMenu}/>
                                </MenuItem>
                            </ConnectionDialogMoreMenu> */}
                            <div id="react-admin-dialog-title" ></div>
                            <IconButton
                                color="primary"
                                aria-label="cancel"
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                    </DialogTitle>
                    <DialogContent sx={{ pb: 0 }} dividers>

                    {['jobber', 'salesforce']?.includes(connection.service) && connection.status !=='authorized' ? <>
                    <div className='integration-modal-logos'>
                        <span className='protiv-integration-logo'><img src={protivLogo} alt='logo' /></span>
                        {INTEGRATION_RIGHT_ARROW()}
                        <span><img src={connection.logo} alt={connection.name} /></span>
                    </div>
                    <div className='integration-modal-head'>
                        Allow Protiv to access your <br />{connection.name} Account
                    </div>
                    </>
                    :
                    <>
                    <div className='integration-modal-logos'>
                        <span><img src={connection.logo} alt={connection.name} /></span>
                    </div>
                    <div className='integration-modal-head'>
                        {connection.name} Authentication
                    </div>
                    <br/>
                    </>}
                    <Stack
                        direction="column"
                        alignItems="center"
                        sx={{pb: 0, pl: 0, pr: 0 }}
                        width='100%'
                    >
                        <Box width='98%' sx={{mb:2}}>
                            {connection.service === 'jobber' && <VaultConnectionJobberForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'aspire' && <VaultConnectionAspireForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'tsheet' && <VaultConnectionTSheetForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'buddypunch' && <VaultConnectionBuddypunchForm configurationKeys={configurationKeys}/>}
                            {connection.service === 'procore' && <VaultConnectionProcoreForm configurationKeys={configurationKeys} status={connection.status} configuration={connection.configuration} />}
                            {connection.service === 'servicetitan' && <VaultConnectionServiceTitanForm configurationKeys={configurationKeys} />}
                            {(connection.service.startsWith("apify-") || connection.service === 'busybusy' || connection.service === 'arborgold' || connection.service === 'exaktime') && <VaultConnectionBusyBusyForm service={connection.service} />}
                        </Box>
                        <Typography variant="body2" color="error">
                        {params.get('error')}
                        </Typography>
                        <Typography variant="body2" color="error">
                        {error}
                        </Typography>
                    </Stack>

                    </DialogContent>
                    <DialogActions className='button-justified vault-connector-toolbar'>
                        <StyledToolbar
                            sx={{
                                background:'none!important',
                                padding:0,
                                margin:0,
                                minHeight:'inherit!important'
                            }}
                            record={formProps.record}
                            invalid={formProps.invalid}
                            handleSubmit={formProps.handleSubmit}
                            handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                            saving={formProps.saving}
                            basePath={''}>
                        <Button className='cancel-button' onClick={handleClose}>Cancel</Button>{' '}
                        {(!connection.status || connection.status === "not_authorized") &&
                            (loading ?
                            <LoadingButton className='update-button' loading={loading} disabled={true} onClick={onClickAuthorize}>Authenticate</LoadingButton> :
                            <SaveButton size="small" fullWidth className='update-button' label='Authenticate' saving={loading} disabled={loading} onSave={onClickAuthorize} />)}

                        {(connection.status === "authorized") &&
                            (saveLoading ? <LoadingButton className='update-button' loading={loading} disabled={true} onClick={onClickAuthorize}>Save</LoadingButton> :
                            <SaveButton size="small" fullWidth className='update-button' label='Save' saving={saveLoading} disabled={saveLoading} onSave={onClickSave} />)}
                        </StyledToolbar>
                     </DialogActions>
                </Dialog>
            );
        }}
        />
    )
};
const DisconnectMenuItem = ({connection, closeMenu}) => {
    const [open, setOpen] = useState(false);
    const queryClient = useQueryClient();
    const {disconnectConnection, isLoading:isLoadingDisconnect} = useDisconnectConnection()
    const onClickConfirmDisconnect = useCallback(()=>{
        setOpen(false)
        disconnectConnection({id: connection.id}, {
            onSuccess:(connection)=>{
                console.log("Connection disconnected", connection)
                queryClient.refetchQueries();
                closeMenu()
            },
        })
    },[setOpen, disconnectConnection, connection, closeMenu])

    const onClickDisconnect = useCallback(()=>{
        setOpen(true)
    },[setOpen])

    const onCancel = useCallback(()=>{
        setOpen(false)
    },[setOpen])


    return  (
        <>
            <LoadingButton
                disabled={isLoadingDisconnect}
                onClick={onClickDisconnect}
            >
                {isLoadingDisconnect && (
                    <CircularProgress size={25} thickness={2} />
                )}
                Disconnect
            </LoadingButton>
            <AlertDialog name={connection.name} open={open} onCancel={onCancel} onConfirm={onClickConfirmDisconnect}/>
        </>
    )
}


export default function AlertDialog({ name, open, onCancel, onConfirm }) {
    return (
        <Dialog
            onClose={onCancel}
            aria-labelledby="Salesforces-Configuration-title"
            open={open}
            className='common-dialog-modal integration-connect-modal'
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="Salesforces-Configuration-dialog-title">
                <IconButton
                    aria-label="close"
                    onClick={onCancel}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <div className='duplicate-cont-body'>
                    <div className='duplicate-alert-icon'>{ALERT_LARGE_ICON()}</div>
                    <div className='duplicate-cont-p'>This will stop your <b>{name}</b> integration. Are you sure you want to continue?</div>
                </div>
            </DialogContent>
            <DialogActions className='button-justified'>
                <Button className='cancel-button' onClick={onCancel} autoFocus>Cancel</Button>
                <LoadingButton loading={false} disabled={false} className='update-button' onClick={() => onConfirm()}>Continue</LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

  function ConnectionDialogMoreMenu({children, isOpen, setIsOpen}){
    const ref = useRef(null);
        return (<>
            <IconButton ref={ref} onClick={() => setIsOpen(true)}>
                <Icon fr='' icon={moreVerticalFill} width={20} height={20} />
            </IconButton>
            <Menu
                open={isOpen}
                anchorEl={ref.current}
                onClose={() => setIsOpen(false)}
                PaperProps={{
                    sx: { width: 200, maxWidth: '100%' }
                }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                {children}
            </Menu>
        </>)
    }

    const classes = {
        root: `DialogAction-root`,
    };

const StyledToolbar =  styled(AdminToolbar)({
    '&.RaToolbar-mobileToolbar': {
        position: 'relative'
    },
    '&.RaToolbar-toolbar':{
        backgroundColor:'#FFF'
    },
    '&.RaToolbar-desktopToolbar':{
        backgroundColor:'#FFF',
        marginTop:'unset'
    },
});

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
    [`&.MuiDialogActions-root.${classes.root}`]: {
        padding:theme.spacing(2)
    },
}));
